import { render, staticRenderFns } from "./menusis.vue?vue&type=template&id=2d81421c&scoped=true"
import script from "./menusis.vue?vue&type=script&lang=js"
export * from "./menusis.vue?vue&type=script&lang=js"
import style0 from "./menusis.vue?vue&type=style&index=0&id=2d81421c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81421c",
  null
  
)

export default component.exports